<template>
  <v-sheet class="text-center">
    <img class="mt-6 mb-3" :src="require('@/assets/appLogo-color--Onlight.svg')" width="45"/>
    <span class="d-block caption">Estás recibiendo este email porque eres cliente de {{account.name}}, quien utiliza Piriod para sus procesos de facturación y pagos.</span>
  </v-sheet>
</template>
<script>
import GenericViewMixin from '@/mixins/GenericViewMixin'
export default {
  mixins: [
    GenericViewMixin
  ]
}
</script>